var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5H1.33333C0.873096 0.5 0.5 0.873096 0.5 1.33333V7.16667C0.5 7.6269 0.873096 8 1.33333 8H5.5C5.96024 8 6.33333 7.6269 6.33333 7.16667V1.33333C6.33333 0.873096 5.96024 0.5 5.5 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 0.5H10.5C10.0398 0.5 9.66667 0.873096 9.66667 1.33333V3.83333C9.66667 4.29357 10.0398 4.66667 10.5 4.66667H14.6667C15.1269 4.66667 15.5 4.29357 15.5 3.83333V1.33333C15.5 0.873096 15.1269 0.5 14.6667 0.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 8H10.5C10.0398 8 9.66667 8.3731 9.66667 8.83333V14.6667C9.66667 15.1269 10.0398 15.5 10.5 15.5H14.6667C15.1269 15.5 15.5 15.1269 15.5 14.6667V8.83333C15.5 8.3731 15.1269 8 14.6667 8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.3333H1.33333C0.873096 11.3333 0.5 11.7064 0.5 12.1667V14.6667C0.5 15.1269 0.873096 15.5 1.33333 15.5H5.5C5.96024 15.5 6.33333 15.1269 6.33333 14.6667V12.1667C6.33333 11.7064 5.96024 11.3333 5.5 11.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar1);
export default __webpack_public_path__ + "static/media/sidebar-1.d0057c396f00cf996a4d442339a4e4f8.svg";
export { ForwardRef as ReactComponent };